import { render } from "./StocK.vue?vue&type=template&id=b7184496&scoped=true"
import script from "./StocK.vue?vue&type=script&lang=js"
export * from "./StocK.vue?vue&type=script&lang=js"

import "./StocK.vue?vue&type=style&index=0&id=b7184496&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7184496"]])

export default __exports__